import { render, staticRenderFns } from "./other-setting.vue?vue&type=template&id=125f3283&"
import script from "./other-setting.vue?vue&type=script&lang=js&"
export * from "./other-setting.vue?vue&type=script&lang=js&"
import style0 from "./other-setting.vue?vue&type=style&index=0&id=125f3283&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports